import {
  Asset,
  PatientDocument,
  RecipeInfo,
} from "@physiofit-digital/physiofit_types";
import * as Sentry from "@sentry/react";
import { arrayUnion } from "firebase/firestore";
import { editPracticePatient } from "../../../core/firestoreConnect/editPracticePatient";
import { getPracticePatientId } from "../../../core/store/currentFormSlice";
import { useMainStore } from "../../../core/store/mainStore";
import { getUuid } from "../../../core/utils/helpers";

// The files already sit in Storage at this point; this write is what links them
// to the patient record. A failure here therefore loses the upload silently
// unless it is reported back, hence the boolean result (PF-5637).
export const handleDocumentAndRecipeUpload = async (
  assets: Asset[],
  isRecipe?: boolean,
): Promise<boolean> => {
  if (!assets || assets.length === 0) {
    return true;
  }
  const state = useMainStore.getState();
  const practicePatientId = getPracticePatientId(state);
  if (!practicePatientId) {
    const error = new Error(
      "No practice patient ID found. Cannot link uploaded assets.",
    );
    console.error(error);
    Sentry.captureException(error);
    return false;
  }

  if (isRecipe) {
    const recipe: RecipeInfo = {
      recipeId: `recipe-${Date.now()}`,
      assets: assets.map((asset) => ({
        assetUrl: asset.assetUrl,
        type: asset.type,
        mimeType: asset.mimeType,
        internalName: asset.internalName,
      })),
      uploadedAt: new Date().toISOString(),
    };
    return editPracticePatient(practicePatientId, {
      ["recipesInfo"]: arrayUnion(recipe),
    });
  }

  const documents: PatientDocument[] = assets.map((asset) => ({
    id: getUuid(),
    downloadUrl: asset.assetUrl,
    name: asset.internalName,
    uploadedAt: new Date().toISOString(),
    uploadedBy: "patient",
  }));
  return editPracticePatient(practicePatientId, {
    ["documentsInfo"]: arrayUnion(...documents),
  });
};
